export enum ELoginProvider {
  google = 'google',
  apple = 'apple',
  facebook = 'facebook',
  email = 'email',
}

export enum ELoginProvidersViewType {
  vertical = 'vertical',
  horizontal = 'horizontal',
}
